import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {store} from '@/store';
import {Breadcrumb} from '@/core/router/interface/breadcrumb.interface';

@Module({
    dynamic: true,
    namespaced: true,
    name: 'router',
    store,
})
export class RouterStore extends VuexModule {
    breadcrumbs: Breadcrumb[] = [];

    @Mutation
    mSetBreadcrumbs(breadcrumbs: Breadcrumb[]): void {
        this.breadcrumbs = breadcrumbs;
    }

    @Action
    aSetBreadcrumbs(breadcrumbs: Breadcrumb[]): void {
        this.mSetBreadcrumbs(breadcrumbs);
    }
}
